import './bootstrap';
import pdfAnnotationViewer from './components/pdf-annotation-viewer';
import auroraWidget from './components/aurora-widget';

// Register the PDF annotation viewer component globally
window.pdfAnnotationViewer = pdfAnnotationViewer;

// Aurora tray widget factory must exist before Alpine.start() and survive
// Livewire morphs / Turbo swaps — see resources/js/components/aurora-widget.js
window.auroraWidget = window.auroraWidget || auroraWidget;

// Google Places address components. Factories live in the bundle (not inline
// blade scripts) so components added by Livewire morphs stay alive, and manual
// entry works with Google down — see resources/js/lib/google-maps-loader.js.
import alvvaParsePlace from './lib/google-place-parser';
import enhancedAddressAutocomplete from './components/enhanced-address-autocomplete';
import addressHistoryInput from './components/address-history-input';
import addressHistoryMultiInput from './components/address-history-multi-input';
import birthPlaceAutocomplete from './components/birth-place-autocomplete';
import payBillingAutocomplete from './components/pay-billing-autocomplete';
import cityStateCombinedInput from './components/city-state-combined-input';
import employmentInput from './components/employment-input';
import employmentHistoryInput from './components/employment-history-input';

window.alvvaParsePlace = window.alvvaParsePlace || alvvaParsePlace;
window.enhancedAddressAutocomplete = window.enhancedAddressAutocomplete || enhancedAddressAutocomplete;
window.addressHistoryInput = window.addressHistoryInput || addressHistoryInput;
window.addressHistoryMultiInput = window.addressHistoryMultiInput || addressHistoryMultiInput;
window.birthPlaceAutocomplete = window.birthPlaceAutocomplete || birthPlaceAutocomplete;
window.payBillingAutocomplete = window.payBillingAutocomplete || payBillingAutocomplete;
window.cityStateCombinedInput = window.cityStateCombinedInput || cityStateCombinedInput;
window.employmentInput = window.employmentInput || employmentInput;
window.employmentHistoryInput = window.employmentHistoryInput || employmentHistoryInput;
